import { render } from "./UpdateLocal.vue?vue&type=template&id=0ab93236&scoped=true"
import script from "./UpdateLocal.vue?vue&type=script&lang=js"
export * from "./UpdateLocal.vue?vue&type=script&lang=js"

import "./UpdateLocal.vue?vue&type=style&index=0&id=0ab93236&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0ab93236"

export default script